import { Scenario } from "@opstel/query/api/scenario";
import { useDetailPanelData } from "@opstel/SBD/components/useDetailPanelData";
import { useLocalStorage } from "@uidotdev/usehooks";
import { useCallback } from "react";
import { useSelectedTimeStore } from "../contexts/SelectedTime/useSelectedTimeStore";
import { useZoomStore } from "../contexts/zoomLevel/useSbdZoom";

interface StorageManager {
  /**
   *
   * @deprecated Instance id which is stable over rerenders.
   */
  instanceId: string;

  /**
   * Resets the local storage if instance has changed.
   */
  prepareStore: (scenario: Scenario) => void;
}

const INSTANCE_ID_STORAGE_KEY = "instance-id";
export function useLocalStorageManager(): StorageManager {
  const [instanceId, setInstanceId] = useLocalStorage<string>(INSTANCE_ID_STORAGE_KEY);
  const resetZoomLevel = useZoomStore((state) => state.resetZoomLevel);
  const setScenarioInterval = useSelectedTimeStore((state) => state.setScenarioInterval);
  const clearDetailPanelData = useDetailPanelData((state) => state.clearDetailPanelData);

  const prepareStore = useCallback(
    (scenario: Scenario) => {
      const scenarioInterval = scenario.scenarioStart.until(scenario.scenarioEnd);
      if (instanceId !== scenario.instanceId) {
        localStorage.clear();
        setInstanceId(scenario.instanceId);
        resetZoomLevel();
        setScenarioInterval(scenarioInterval);
        clearDetailPanelData();
        return;
      }
      // A second tab shares the instance id via localStorage, but has its own empty in-memory store.
      if (!useSelectedTimeStore.getState().scenarioInterval) {
        setScenarioInterval(scenarioInterval);
      }
    },
    [instanceId, setInstanceId, resetZoomLevel, setScenarioInterval, clearDetailPanelData],
  );
  return { instanceId, prepareStore };
}
